document
  .querySelector(".product-form")
  .addEventListener("change", function (e) {
    updateBundleCustomInventory();
  });

document.addEventListener("DOMContentLoaded", function () {
  updateBundleCustomInventory();
});

function updateBundleCustomInventory() {
  // console.log("[Primal Bundle] Updating custom inventory messages");
  const container = document.getElementById(divId);
  // console.log("[Primal Bundle] Found container:", container);
  if (!container) {
    // Observe for when container is added to the DOM
    const observer = new MutationObserver((mutations, obs) => {
      const found = document.getElementById(divId);
      // console.log("[Primal Bundle] Observing DOM for container. Found:", found);
      if (found) {
        obs.disconnect();
        updateBundleCustomInventory();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return;
  }
  //   Get all bundle inputs
  let options = container.querySelectorAll(".bundle-option input");
  // console.log("[Primal Bundle] Found bundle option inputs:", options);
  // Collect all selected variant IDs based on if they're checked or have the class single-bundle-option (Single pre-selected option)
  let selectedVariantIds = Array.from(options)
    .filter(
      (option) =>
        option.checked || option.classList.contains("single-bundle-option"),
    )
    .map((option) => option.getAttribute("data-variant"));

  // console.log(
  //   "[Primal Bundle] Selected variant IDs from bundle options:",
  //   selectedVariantIds,
  // );

  // Hide all pre-existing messages
  document.querySelectorAll(".product-inventory").forEach((el) => {
    el.classList.remove("active");
    el.setAttribute("aria-hidden", "true");
  });

  //   console.log("[Primal Bundle] Hiding all inventory messages");

  // Find matching product inventory messaging
  let allMatchingEls = [];
  selectedVariantIds.forEach((variantId) => {
    if (!variantId) return;
    const matchingEls = document.querySelectorAll(
      `.product-inventory[data-variant-id='${variantId}'], .product-inventory[data-inventory-message-id='${variantId}']`,
    );
    allMatchingEls.push(...matchingEls);

    // console.log(
    //   `[Primal Bundle] Found inventory message elements for variant ${variantId}:`,
    //   matchingEls,
    // );
  });

  // Find the one with the latest available date
  let latestDate = null;
  let latestEl = null;
  allMatchingEls.forEach((el) => {
    let variantId =
      el.getAttribute("data-inventory-message-id") ||
      el.getAttribute("data-variant-id");
    let script = document.querySelector(
      `script[data-variant-custom-inventory='${variantId}']`,
    );
    let availableDate = null;

    // console.log(
    //   "[Primal Bundle] Checking available date for variant:",
    //   variantId,
    // );
    // Compare the available_date from each one to get the latest date
    if (script) {
      try {
        let data = JSON.parse(script.textContent);
        let inv = data.inventory && data.inventory[variantId];
        if (inv && inv.available_date) {
          availableDate = inv.available_date;
        }
      } catch (e) {}
    }
    if (availableDate) {
      if (!latestDate || availableDate > latestDate) {
        latestDate = availableDate;
        latestEl = el;
        // console.log(
        //   "[Primal Bundle] Found latest available date:",
        //   latestDate,
        //   "for element:",
        //   latestEl,
        // );
      }
    }
  });

  // Show all .product-inventory and .block--delivery__info for the variant with the latest available_date
  if (latestEl) {
    // Get the variantId for the latestEl
    let variantId =
      latestEl.getAttribute("data-variant-id") ||
      latestEl.getAttribute("data-inventory-message-id");

    // Activate all .product-inventory elements for this variant
    if (variantId) {
      let inventoryEls = document.querySelectorAll(
        `.product-inventory[data-variant-id='${variantId}'], .product-inventory[data-inventory-message-id='${variantId}']`,
      );
      inventoryEls.forEach((el) => {
        el.classList.add("active");
        el.setAttribute("aria-hidden", "false");
      });
    }

    // Hide all .block--delivery__info elements
    document.querySelectorAll(".block--delivery__info").forEach((el) => {
      el.classList.remove("active");
      el.setAttribute("aria-hidden", "true");
    });

    // Activate all .block--delivery__info elements for this variant
    if (variantId) {
      let deliveryInfos = document.querySelectorAll(
        `.block--delivery__info[data-variant-id='${variantId}']`,
      );
      deliveryInfos.forEach((deliveryInfo) => {
        deliveryInfo.classList.add("active");
        deliveryInfo.setAttribute("aria-hidden", "false");
      });
    }

    // console.log(
    //   "[Primal Bundle] Showing delivery info for variant with latest available_date:",
    //   latestDate,
    // );
  }
}
